module.exports = __webpack_public_path__ + "img/26.699d6b8c.png";